(function() {
  $(function() {
    return $.widget('custom.resizr', {
      options: {
        parent: null,
        siblings: null,
        widthSiblings: null,
        use_max: null,
        use_width: null,
        fudge: 0,
        new_size: null
      },
      sizeCalc: null,
      widthCalc: null,
      _init: function() {
        return this.resize();
      },
      _create: function() {
        return void 0;
      },
      _setOption: function() {
        return void 0;
      },
      destroy: function() {
        return void 0;
      },
      resize: function() {
        var padding, parent, ref, ref1, ref2, sibheight, siblings, sibwidth, size;
        parent = ((ref = this.options.parent) != null ? ref : this.element.parent()).height();
        siblings = (ref1 = this.options.siblings) != null ? ref1 : this.element.siblings();
        sibheight = 0;
        siblings.each(function() {
          if ($(this).prop('tagName') !== 'STYLE' && $(this).css('position') !== 'absolute') {
            return sibheight += $(this).outerHeight(true);
          }
        });
        padding = this.element.outerHeight(true) - this.element.height();
        if (this.options.new_size != null) {
          size = this.options.new_size;
        } else {
          size = parent - sibheight - padding;
          size = size + this.options.fudge;
        }
        this.sizeCalc = size;
        this.widthCalc = this.element.width();
        if (this.options.use_max) {
          this.element.css({
            'max-height': size + 'px'
          });
        } else {
          this.element.css({
            height: size + 'px'
          });
        }
        if (this.options.use_width) {
          parent = ((ref2 = this.options.parent) != null ? ref2 : this.element.parent()).width();
          siblings = this.options.widthSiblings;
          sibwidth = 0;
          if (siblings != null) {
            siblings.each(function() {
              return sibwidth += $(this).outerWidth(true);
            });
          }
          padding = this.element.outerWidth(true) - this.element.width();
          size = parent - sibwidth - padding;
          if (size < this.widthCalc) {
            this.widthCalc = size;
            if (this.options.use_max) {
              this.element.css({
                'max-width': size + 'px'
              });
            } else {
              this.element.css({
                width: size + 'px'
              });
            }
          }
        }
        return size;
      },
      size: function() {
        return this.sizeCalc;
      },
      width: function() {
        return this.widthCalc;
      }
    });
  });

}).call(this);
